(() => {
  if (window.AndCartDrawerStabilityV3) return;
  window.AndCartDrawerStabilityV3 = true;

  const STYLE_ID = 'and-cart-drawer-stability-style';
  const PENDING_CLASS = 'and-cart-loading';
  const CART_DRAWER_ID = 'CartDrawer';
  let addInFlight = false;

  const root = () => (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const route = (path) => `${root()}${path}`.replace(/\/+/g, '/');
  const drawer = () => document.getElementById(CART_DRAWER_ID);

  const ensureStyle = () => {
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      .${PENDING_CLASS}{position:relative!important;pointer-events:none!important;color:transparent!important}
      .${PENDING_CLASS}::after{content:'';position:absolute;left:50%;top:50%;width:18px;height:18px;margin:-9px 0 0 -9px;border:2px solid rgba(255,255,255,.45);border-top-color:#fff;border-radius:50%;animation:and-cart-spin .7s linear infinite}
      #CartDrawer .${PENDING_CLASS}{opacity:.55;cursor:wait;color:inherit!important}
      #CartDrawer .${PENDING_CLASS}::after{border-color:rgba(0,0,0,.22);border-top-color:#111}
      @keyframes and-cart-spin{to{transform:rotate(360deg)}}
    `;
    document.head.appendChild(style);
  };

  const unlockScroll = () => {
    const classes = ['overflow-hidden','lock-scroll','no-scroll','scroll-lock','drawer-open','cart-drawer-open','js-drawer-open','js-drawer-open-cart','has-modal-open','has-modal-opening','modal-open','overflow-hidden-mobile','overflow-hidden-tablet','is-locked','is-scroll-locked','noscrl'];
    [document.documentElement, document.body].forEach((el) => {
      if (!el) return;
      classes.forEach((className) => el.classList.remove(className));
      ['overflow','overflowX','overflowY','position','top','left','right','width','height','touchAction','pointerEvents'].forEach((prop) => { el.style[prop] = ''; });
    });
    document.querySelectorAll('[inert]').forEach((el) => {
      if (!el.closest('#CartDrawer')) el.removeAttribute('inert');
    });
    document.body.removeAttribute('data-scroll-locked');
  };

  const updateCartCount = (count) => {
    document.querySelectorAll('[data-cart-count], .cart-count, cart-count').forEach((node) => {
      node.textContent = count;
      node.hidden = count < 1;
    });
    document.querySelectorAll('[data-cart-count-bubble], .cart-count-bubble').forEach((node) => {
      node.hidden = count < 1;
    });
  };

  const openDrawer = () => {
    const current = drawer();
    if (!current) return false;
    current.hidden = false;
    current.removeAttribute('hidden');
    try { if (typeof current.show === 'function') current.show(null, false); } catch (error) {}
    current.setAttribute('open', '');
    current.classList.add('is-open', 'active');
    document.querySelectorAll('[aria-controls="CartDrawer"]').forEach((node) => node.setAttribute('aria-expanded', 'true'));
    return true;
  };

  const closeDrawer = () => {
    const current = drawer();
    if (!current) return;
    try { if (typeof current.hide === 'function') current.hide(false); } catch (error) {}
    current.removeAttribute('open');
    current.classList.remove('is-open', 'active');
    current.hidden = true;
    document.querySelectorAll('[aria-controls="CartDrawer"]').forEach((node) => node.setAttribute('aria-expanded', 'false'));
    unlockScroll();
    setTimeout(unlockScroll, 80);
    setTimeout(unlockScroll, 250);
    setTimeout(unlockScroll, 700);
  };

  const replaceDrawer = (html) => {
    if (!html) return false;
    const next = new DOMParser().parseFromString(html, 'text/html').getElementById(CART_DRAWER_ID);
    const current = drawer();
    if (!next || !current) return false;
    current.replaceWith(next);
    return true;
  };

  const fetchFreshDrawerHtml = async () => {
    const bust = `and_cart_ts=${Date.now()}`;
    const url = new URL(window.location.href);
    url.searchParams.set('view', url.searchParams.get('view') || '');
    url.searchParams.delete('view');
    url.searchParams.set('_and_cart', bust);
    const response = await fetch(url.toString(), {
      credentials: 'same-origin',
      headers: { Accept: 'text/html', 'X-Requested-With': 'XMLHttpRequest' }
    });
    return response.text();
  };

  const refreshDrawer = async (shouldOpen = true) => {
    const [cart, html] = await Promise.all([
      fetch(route('cart.js'), { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then((res) => res.json()).catch(() => null),
      fetchFreshDrawerHtml().catch(() => '')
    ]);
    replaceDrawer(html);
    if (cart && typeof cart.item_count === 'number') updateCartCount(cart.item_count);
    if (shouldOpen) openDrawer();
  };

  const renderCartResponse = async (data, shouldOpen = true) => {
    const id = drawer()?.dataset.sectionId;
    let rendered = false;
    if (id && data && data.sections && data.sections[id]) rendered = replaceDrawer(data.sections[id]);
    if (data && typeof data.item_count === 'number') updateCartCount(data.item_count);
    if (!rendered) await refreshDrawer(false);
    if (shouldOpen) openDrawer();
  };

  const activeVariantId = (form) => {
    const enabled = form.querySelector('[name="id"]:not(:disabled)');
    if (enabled && enabled.value) return enabled.value;
    const anyId = form.querySelector('[name="id"]');
    if (anyId && anyId.value) return anyId.value;
    const selected = form.querySelector('select[name="id"] option:checked');
    if (selected && selected.value) return selected.value;
    const checked = form.querySelector('input[name="id"][type="radio"]:checked');
    if (checked && checked.value) return checked.value;
    const variantPicker = document.querySelector('variant-selects, variant-radios, [data-product-json]');
    const current = variantPicker?.currentVariant || window.currentVariant || window.selectedVariant;
    return current && current.id ? current.id : '';
  };

  const setButtonLoading = (button, loading) => {
    if (!button) return;
    ensureStyle();
    button.classList.toggle(PENDING_CLASS, loading);
    button.disabled = loading;
    button.setAttribute('aria-busy', loading ? 'true' : 'false');
  };

  const ajaxAddForm = async (form, submitter) => {
    if (!form || form.closest('#CartDrawer') || addInFlight) return;
    const variantId = activeVariantId(form);
    if (!variantId) return;

    addInFlight = true;
    setButtonLoading(submitter, true);

    try {
      const formData = new FormData(form);
      formData.set('id', variantId);
      if (!formData.get('quantity')) formData.set('quantity', '1');

      const response = await fetch(route('cart/add.js'), {
        method: 'POST',
        credentials: 'same-origin',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      });
      const data = await response.json();
      if (!response.ok || data.status === 422) throw new Error(data.description || data.message || 'Add to cart failed');
      await renderCartResponse(data, true);
    } catch (error) {
      console.error('[cart drawer ajax add]', error);
      const errorBox = form.querySelector('.product-form__error-message, [data-error-message]');
      if (errorBox) {
        errorBox.textContent = error.message || 'Unable to add this item to cart.';
        errorBox.hidden = false;
      } else {
        alert(error.message || 'Unable to add this item to cart.');
      }
    } finally {
      addInFlight = false;
      setTimeout(() => setButtonLoading(submitter, false), 350);
    }
  };

  const findProductForm = (target) => {
    const button = target.closest('button[name="add"], .product-form__submit, [type="submit"][form], [data-add-to-cart], [data-product-submit]');
    if (!button || button.closest('#CartDrawer')) return null;
    const formId = button.getAttribute('form');
    const form = formId ? document.getElementById(formId) : button.closest('form');
    if (!form || !/\/cart\/add/.test(form.getAttribute('action') || form.action || '')) return null;
    return { form, button };
  };

  document.addEventListener('click', (event) => {
    const product = findProductForm(event.target);
    if (!product) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    ajaxAddForm(product.form, product.button);
  }, true);

  document.addEventListener('submit', (event) => {
    const form = event.target.closest && event.target.closest('form[action*="/cart/add"]');
    if (!form || form.closest('#CartDrawer')) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    const submitter = event.submitter || form.querySelector('button[name="add"], .product-form__submit, [type="submit"]');
    ajaxAddForm(form, submitter);
  }, true);

  const postJson = async (path, body) => {
    const response = await fetch(route(path), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    });
    const data = await response.json();
    if (!response.ok || data.errors) throw new Error(data.errors || data.description || 'Cart request failed');
    return data;
  };

  document.addEventListener('click', async (event) => {
    if (!event.target.closest('#CartDrawer')) return;

    if (event.target.closest('[data-and-cart-close]') || event.target.closest('.and-cart-overlay')) {
      event.preventDefault();
      closeDrawer();
      return;
    }

    const qtyButton = event.target.closest('[data-and-cart-qty][data-and-cart-key]');
    if (qtyButton) {
      event.preventDefault();
      const holder = qtyButton.closest('.and-cart-qty') || qtyButton;
      setButtonLoading(holder, true);
      try {
        await postJson('cart/change.js', { id: qtyButton.dataset.andCartKey, quantity: Math.max(0, Number(qtyButton.dataset.andCartQty || 0)) });
        await refreshDrawer(true);
      } finally {
        setButtonLoading(holder, false);
      }
      return;
    }

    const removeButton = event.target.closest('[data-and-cart-remove]');
    if (removeButton) {
      event.preventDefault();
      await postJson('cart/change.js', { id: removeButton.dataset.andCartRemove, quantity: 0 });
      await refreshDrawer(true);
      return;
    }

    const recButton = event.target.closest('[data-and-rec-add]');
    if (recButton && !recButton.disabled) {
      event.preventDefault();
      setButtonLoading(recButton, true);
      try {
        await postJson('cart/add.js', { id: Number(recButton.dataset.andRecAdd), quantity: 1 });
        await refreshDrawer(true);
      } finally {
        setButtonLoading(recButton, false);
      }
    }
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeDrawer();
  });

  window.AndskyCartDrawer = window.AndskyCartDrawer || {};
  window.AndskyCartDrawer.open = openDrawer;
  window.AndskyCartDrawer.close = closeDrawer;
  window.AndskyCartDrawer.unlockScroll = unlockScroll;
  window.AndskyCartDrawer.refresh = refreshDrawer;
})();
